import { queryOptions } from '@tanstack/react-query';
import { GetEvaluationSummaryQueryParamsType } from './getEvaluationSummaryQuery.type';
import { getEvaluationSummaryFunction } from './getEvaluationSummaryQueryFunction';

export const getEvaluationSummaryQueryOptions = (
  params: GetEvaluationSummaryQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['EvaluationSummary', params],
    queryFn: () => getEvaluationSummaryFunction(params),
  });
};
